/**
 * CDN Configuration for static assets
 * All static images are served from Cloudflare R2 CDN
 */

// Cloudflare R2 public URL
export const CDN_URL = 'https://images.frenflow.com';

// Prefix for web app static assets
export const STATIC_PREFIX = 'static/web';

/**
 * Get CDN URL for a static asset
 * @param path - Path relative to public folder (e.g., "/logo.png" or "logo.png")
 * @returns Full CDN URL
 *
 * @example
 * cdn('/polymarket-logo.png') => 'https://pub-xxx.r2.dev/static/web/polymarket-logo.png'
 * cdn('logos/ninja.png') => 'https://pub-xxx.r2.dev/static/web/logos/ninja.png'
 */
export function cdn(path: string): string {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${CDN_URL}/${STATIC_PREFIX}/${cleanPath}`;
}

/**
 * Common static assets with CDN URLs
 * Use these for frequently used images
 */
export const STATIC_ASSETS = {
  // Brand
  logo: cdn('brand/frenflow_logo.png'),
  logoLight: cdn('brand/frenflow_logo_light.png'),
  logoWhite: cdn('logo-white.svg'),
  logoBlack: cdn('logo-black.svg'),

  // Favicons
  favicon: cdn('favicon.ico'),
  faviconSvg: cdn('favicon.svg'),
  appleTouchIcon: cdn('apple-touch-icon.png'),

  // Platform logos
  polymarket: {
    iconBlue: cdn('logos/polymarket/icon-blue.png'),
    iconWhite: cdn('logos/polymarket/icon-white.png'),
    logoBlue: cdn('logos/polymarket/logo-blue.png'),
    logoWhite: cdn('logos/polymarket/logo-white.png'),
  },
  kalshi: {
    logo: cdn('kalshi-logo.png'),
    logoSvg: cdn('logos/kalshi/kalshi-logo.svg'),
  },
  predict: {
    iconBP: cdn('logos/predictfun/Predict-Icon-BP.png'),
    iconPB: cdn('logos/predictfun/Predict-Icon-PB.png'),
    logoDark: cdn('logos/predictfun/Predict-Logo-Dark.svg'),
    logoWhite: cdn('logos/predictfun/Predict-Logo-White.svg'),
  },

  // UI elements
  usdc: cdn('usdc.png'),
  ninja: cdn('logos/ninja.png'),
  polygonscan: cdn('polygonscan.png'),

  // Default avatars
  defaultAvatar: cdn('avatar.webp'),

  // Telegram bot images (for reference)
  telegram: {
    start: cdn('start.webp'),
    wallet: cdn('wallet.webp'),
    copy: cdn('copy.webp'),
    settings: cdn('settings.webp'),
    notifications: cdn('notifications.webp'),
    stats: cdn('stats.webp'),
    referrals: cdn('referrals.webp'),
    tracker: cdn('tracker.webp'),
    leaderboard: cdn('leaderboard.webp'),
    polymarket: cdn('polymarket.webp'),
    momentum: cdn('momentum.webp'),
    momentumUp: cdn('momentum_up.webp'),
    momentumDown: cdn('momentum_down.webp'),
    positionResolved: cdn('position_resolved.webp'),
  },
} as const;
